/*
Copyright 2022 by Herbert Potechius,
Ernst-Abbe-Hochschule Jena - University of Applied Sciences - Department of Electrical Engineering and Information
Technology - Immersive Media and AR/VR Research Group.
All rights reserved.
This file is released under the "MIT License Agreement".
Please see the LICENSE file that should have been included as part of this package.
*/
import React, {Suspense, useMemo, useRef, useEffect, useState, useCallback} from 'react';
import { OBJLoader } from 'three/examples/jsm/loaders/OBJLoader'
import { MTLLoader } from 'three/examples/jsm/loaders/MTLLoader'
import { useLoader, useFrame } from "@react-three/fiber";
import SystemConfiguration from 'settings/SystemConfiguration';
import * as THREE from "three";

import PointShader from "shader/PointShader"

const vertexShader = PointShader.vertexShader
const fragmentShader = PointShader.fragmentShader


function PointCloud (props){
    const [wireframeEnabled, setWireframeEnabled] = useState(false)

    var objd = useLoader(OBJLoader, process.env.PUBLIC_URL + '/' + props.file_name +'.obj')



    SystemConfiguration.mesh = objd.children[0]


    objd.children[0].geometry.computeBoundingSphere();
    console.log(objd.children[0].geometry.boundingSphere)
    var center = objd.children[0].geometry.boundingSphere.center
    var radius = objd.children[0].geometry.boundingSphere.radius
    var scaling = 1.0 / radius




    let ref = useRef()
    useFrame(() => {
        ref.current.material.uniforms.pointsize = {value: 10.0}
    })



    let data = useMemo(
        () => ({
          uniforms: {
            Ka: { value: new THREE.Vector3(1, 1, 1) },
            Kd: { value: new THREE.Vector3(1, 1, 1) },
            Ks: { value: new THREE.Vector3(1, 1, 1) },
            LightIntensity: { value: new THREE.Vector4(1.0, 1.0, 1.0, 1.0) },
            LightPosition: { value: new THREE.Vector4(0.0, 2000.0, 0.0, 1.0) },
            Shininess: { value: 500.0 }
          },
          fragmentShader,
          vertexShader
        }),
        []
    )


    var coords = new Float32Array(objd.children[0].geometry.attributes.position.array)
    //let normals = new Float32Array(objd.children[0].geometry.attributes.normal.array)
    var colors = new Float32Array(objd.children[0].geometry.attributes.color.array)


    return (
        <group position={[-center.x*scaling, -center.y*scaling + 1.0, -center.z*scaling]} scale={scaling}>
            <points key={Math.random} ref={ref}>
                <bufferGeometry>
                    <bufferAttribute attach="attributes-position" count={coords.length / 3} array={coords} itemSize={3} usage={THREE.DynamicDrawUsage}/>
                    {/* <bufferAttribute attachObject={["attributes", "normal"]} count={normals.length / 3} array={normals} itemSize={3} /> */}
                    <bufferAttribute attach="attributes-color" count={colors.length / 3} array={colors} itemSize={3} usage={THREE.DynamicDrawUsage}/>
                </bufferGeometry>
                <shaderMaterial attach="material" {...data} />
            </points>
        </group>
    );




    
}

export default PointCloud;